import "./scorecardHome.css";
import "../../../index.css";
import { useEffect, useState } from "react";

const ScorecardHomeSubHeader = () => {
  const [scrolled, setScrolled] = useState(false);
  const [headerHeight, setHeaderHeight] = useState(null);

  useEffect(() => {
    const header = document.querySelector("header");
    const headerHeight = header ? header.offsetHeight : 0;
    setHeaderHeight(headerHeight);

    let last = null;
    const handleScroll = () => {
      const y = window.scrollY;
      let next = null;

      if (y > 150) next = true;
      else if (y < 50) next = false;

      if (next !== null && next !== last) {
        handleResize();
        setScrolled(next);
        last = next;
      }
    };

    const handleResize = () => {
      const newHeight = header ? header.offsetHeight : 0;
      setHeaderHeight(newHeight);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div
      style={{ top: headerHeight }}
      className={`scorecard-sub-container ${
        scrolled ? "default-style" : "initial-style"
      }`}
    >
      <div className="scorecard-sub-header">
        <div className="logo-group">
          <img src="/images/header-footer/cd-logo.png" alt="CrowdDoing Logo" />
          {/* <img src="/images/header-footer/CWPCLogoW.png" alt="CWPC Logo" />*/}
          <img src="/images/header-footer/newlogo3.svg" alt="CWPC Logo" />
          <img src="/images/header-footer/arise_wo_bg.png" alt="Arise Logo" />
        </div>
        <div className="header-group">
          <h3 className="title">Community Wildfire Resilience Scorecard</h3>
          <p className="subtitle">
            Empowering Communities Internationally to Assess Wildfire Risk,
            Boost Preparedness
          </p>
        </div>
      </div>
    </div>
  );
};

export default ScorecardHomeSubHeader;
